export default __webpack_public_path__ + "static/media/panda.0253ba0e.png";